import { log } from 'framework/script_utilities/dev-decorators';

export abstract class WidgetBase<TModel, TController> {
  model: TModel;
  controller: TController;
  changing = false;

  @log('debug')
  activate(data: WidgetData<TModel, TController>) {
    this.changing = true;
    this.model = data.model;
    this.controller = data.controller;
    this.changed();
    setTimeout(() => this.changing = false, 0);
  }

  changed() {
    // intentionally empty
  }
}

export interface WidgetData<TModel, TController> {
  model: TModel;
  controller: TController;
}
